import { Dialog, DialogContent, DialogTitle, Tooltip } from "@mui/material";
import { MediaModel } from "../../../models/conversations";
import { MediaType } from "../../../models/media.models";
import ImageComponent from "./image.component";
import Video from "./video.component";
import { CancelSecondaryIcon, DownloadIcon } from "../../../icon";
import * as selector from '../../../selectors/selectors'
import { useSelector } from 'react-redux';

interface Props {
    media: MediaModel;
    open: boolean;
    onClose: () => void;
    senderName: string;
    fileDownload: () => void;
    NoDownloadOption?: boolean;
}

const ViewFullMediaNew = (props: Props) => {
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const IsTeamsApp: boolean = useSelector(selector.isTeamsApp)

    const getComponent = (type: string) => {
        if (type != null) {
            const mediatype = type.split('/')[0];
            switch (mediatype) {
                case MediaType.IMAGE:
                case MediaType.IMAGE_JPEG:
                case MediaType.IMAGE_ARW:
                case MediaType.IMAGE_PNG:
                case MediaType.IMAGE_GIF:
                case MediaType.IMAGE_WEBP:
                    return <ImageComponent MediaUrl={props.media.Url} classname={`${IsMobileDevice ? 'w-p-100' : 'h-v-70'}`} />
                case MediaType.VIDEO:
                    return <Video MediaUrl={props.media.Url} controls={true} />
                default:
                    break;
            }
        }
    }
    const { media } = props;

    return (
        <Dialog fullScreen open={props.open} onClose={props.onClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description" PaperProps={{ classes: { root: "bg-transparent box-shadow-none" } }} >
            <DialogTitle id="alert-dialog-title" className={`bg-color-primary-accent color-secondary`}>
                {!IsMobileDevice ? <div className={`d-flex`}>
                    <span className={"h1-regular "}>{props.senderName}</span>
                    <div className={`ml-auto d-flex my-auto`}>
                       {!props.NoDownloadOption && <Tooltip title='Download' placement='bottom-start'><span className={`mr-4 `}><DownloadIcon onClick={props.fileDownload} className={`c-pointer`} /></span></Tooltip>}
                        <Tooltip title='Close' placement='bottom-start'><span className={`c-pointer`}><CancelSecondaryIcon onClick={props.onClose} /></span></Tooltip>
                    </div>
                </div> :
                    <div className={`d-flex`}>
                        <Tooltip title='Close' placement='bottom-start'><span className={`c-pointer d-flex mr-2 my-auto`}><CancelSecondaryIcon onClick={props.onClose} /></span></Tooltip>
                        <span className={"h3-semibold my-auto"}>{props.senderName}</span>
                        <div className={`ml-auto d-flex my-auto`}>
                            {
                                (IsTeamsApp || props.NoDownloadOption) ? null : <> <Tooltip title='Download' placement='bottom-start'><span ><DownloadIcon onClick={props.fileDownload} className={`c-pointer`} /></span></Tooltip> </>
                            }
                        </div>
                    </div>
                }
            </DialogTitle>
            <DialogContent className={`d-flex justify-center align-center bg-transparent`} dividers>
                {getComponent(media.ContentType)}
            </DialogContent>
        </Dialog>
    )

}


export default ViewFullMediaNew;

